import React, { Component } from 'react';

const initData = {
    heading: "MoneyMonk is available for all devices",
    headingText: "Access instant personal loans anytime, anywhere. MoneyMonk is available across all devices, making it easy to apply, track, and manage your loan with complete convenience and security.",
    headingTexttwo: "Access instant personal loans anytime, anywhere. Money Monk is available across all devices, making it easy to apply, track, and manage your loan with complete convenience and security.",
    headingSlug: "*Available on Android. Coming soon to IOS devices",
    playImg: "/img/google-play.png",
    appleImg: "/img/app-store.png",
}

class Download extends Component {
    state = {
        initData: {}
    }
    componentDidMount(){
        this.setState({
            initData: initData
        })
    }
    render() {
        return (
            <section className="section download-area overlay-dark ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Download Text */}
                        <div className="download-text text-center">
                        <h2 className="text-white">{this.state.initData.heading}</h2>
                        <p className="text-white my-3 d-none d-sm-block">{this.state.initData.headingText}</p>
                        <p className="text-white my-3 d-block d-sm-none">{this.state.initData.headingTexttwo}</p>
                        {/* Store Buttons */}
                        <div className="button-group store-buttons d-flex justify-content-center">
                            <a href="https://play.google.com/store/apps/details?id=com.monkCapital.moneyMonk">
                            <img src={this.state.initData.playImg} alt="" />
                            </a>
                            {/* <a href="/#">
                            <img src={this.state.initData.appleImg} alt="" />
                            </a> */}
                        </div>
                        <span className="d-inline-block text-white fw-3 font-italic mt-3">{this.state.initData.headingSlug}</span>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Download;